import { Auth0Provider } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router';

import { VITE_AUTH0_CLIENT_ID, VITE_AUTH0_DOMAIN } from '@/constants/env';

import type { AppState } from '@auth0/auth0-react';
import type { PropsWithChildren } from 'react';

export function AuthProvider({ children }: PropsWithChildren): React.JSX.Element {
  const navigate = useNavigate();

  const isMissingConfiguration = !VITE_AUTH0_DOMAIN || !VITE_AUTH0_CLIENT_ID;

  if (isMissingConfiguration) {
    return (
      <div>
        Authentication configuration error: Missing Auth0 environment variables. Please ensure
        VITE_AUTH0_DOMAIN and VITE_AUTH0_CLIENT_ID are properly set.
      </div>
    );
  }

  function onRedirectCallback(appState?: AppState): void {
    const defaultPath = window.location.pathname;
    const targetPath = appState?.returnTo;

    if (targetPath) {
      navigate(targetPath);
    } else {
      navigate(defaultPath);
    }
  }

  return (
    <Auth0Provider
      domain={VITE_AUTH0_DOMAIN}
      clientId={VITE_AUTH0_CLIENT_ID}
      onRedirectCallback={onRedirectCallback}
      useRefreshTokens={true}
      authorizationParams={{
        audience: `https://${VITE_AUTH0_DOMAIN}`,
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  );
}
